function Alerts() {
    return(
        <div>
            Alerts
        </div>
    )
}

export default Alerts;